import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragOverlay,
} from '@dnd-kit/core'
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { arrayMove } from '@dnd-kit/sortable'
import { useCallback, useState } from 'react'
import Card from './Card'

const Cards = ({
    cards,
    onCardsReorder,
    isExpanded,
    onToggleExpanded,
    handleInputChange,
    handleDeleteCard,
    goToStep,
    openThumbnailEditor,
    selectedAsset,
    isUpdatingThumbnail,
    setStepContentData,
    handleApplyToAllCards,
    isApplyingToAll,
}) => {
    const [activeId, setActiveId] = useState(null)
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        }),
    )

    const handleDragEnd = useCallback(
        (event) => {
            setActiveId(null)
            const { active, over } = event

            if (active.id !== over.id) {
                const oldIndex = cards.findIndex((card) => card.id === active.id)
                const newIndex = cards.findIndex((card) => card.id === over.id)

                const newCards = arrayMove(cards, oldIndex, newIndex).map((card, index) => ({
                    ...card,
                    position: index,
                }))

                onCardsReorder(newCards)
            }
        },
        [cards, onCardsReorder],
    )

    const handleDragStart = useCallback(({ active }) => {
        setActiveId(active.id)
    }, [])

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
            onDragStart={handleDragStart}
        >
            <SortableContext items={cards.map((card) => card.id)} strategy={verticalListSortingStrategy}>
                {cards.map((card) => (
                    <Card
                        card={card}
                        key={card.id}
                        cards={cards}
                        goToStep={goToStep}
                        selectedAsset={selectedAsset}
                        isApplyingToAll={isApplyingToAll}
                        isExpanded={isExpanded === card.id}
                        onToggleExpanded={onToggleExpanded}
                        handleDeleteCard={handleDeleteCard}
                        handleInputChange={handleInputChange}
                        setStepContentData={setStepContentData}
                        openThumbnailEditor={openThumbnailEditor}
                        isUpdatingThumbnail={isUpdatingThumbnail}
                        handleApplyToAllCards={handleApplyToAllCards}
                    />
                ))}
            </SortableContext>

            {/* Hack to keep the card styling */}
            <DragOverlay>{activeId ? <div></div> : null}</DragOverlay>
        </DndContext>
    )
}

export default Cards
